import { useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import theme from "../../../theme/theme";
import { capitalizeFirstLetter, getBaraStatusColor } from "../../../utils/strings";
import i18n from "../../../i18n-config";
import {
  CustomButton,
  CustomTableFooter,
  StyledTableCell,
  StyledTableRow,
} from "../../../components";

const style = {
  fontSize: 14,
  color: theme.colors.white,
  fontWeight: 550,
};

interface Props {
  data: any;
}

function InfoBaraTable({ data }: Props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer component={Paper} sx={{ mb: 2, boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)", }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow sx={{ bgcolor: theme.colors.primary }}>
            <TableCell sx={style}>
              {capitalizeFirstLetter(i18n.t("id_bara"))}
            </TableCell>
            <TableCell sx={style}>
              {capitalizeFirstLetter(i18n.t("categorie"))}
            </TableCell>
            <TableCell sx={style}>
              {capitalizeFirstLetter(i18n.t("sous_categorie"))}
            </TableCell>
            <TableCell sx={style}>
              {capitalizeFirstLetter(i18n.t("intitule"))}
            </TableCell>
            <TableCell sx={style}>
              {capitalizeFirstLetter(i18n.t("gestionnaire"))}
            </TableCell>
            <TableCell sx={{...style, textAlign: "center"}}>
              {capitalizeFirstLetter(i18n.t("statut"))}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : data
          ).map((item: any, index: any) => (
            <StyledTableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                cursor: "pointer",
              }}
            >
              <StyledTableCell>{item.id}</StyledTableCell>
              <StyledTableCell>{item.categorie?.libelle}</StyledTableCell>
              <StyledTableCell>{item.sousCategorie?.libelle}</StyledTableCell>
              <StyledTableCell>{item.titre}</StyledTableCell>
              <StyledTableCell>{`${item.boss?.nom} ${item.boss?.prenom}`}</StyledTableCell>
              <StyledTableCell style={{ width: 150 }}>
                <CustomButton
                  title={i18n.t(item.statutGeneral)}
                  rootStyle={{
                    backgroundColor: getBaraStatusColor(item.statutGeneral),
                    width: "100%",
                  }}
                  titleStyle={{ fontSize: 12, color: "white" }}
                  disabled
                />
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
        <CustomTableFooter
          rowsPerPage={rowsPerPage}
          data={data}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Table>
    </TableContainer>
  );
}

export default InfoBaraTable;
